<template>

    <div class="trax-struct" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">
            <div class="trax-block trax-level-1" v-for="category in categories" :key="category.id" :data-id="category.id">

                <div class="trax-block-header">
                    <h4>{{ category.name }}</h4>
                </div>

                <div :id="id+'-struct-'+category.id" class="trax-block-body" :data-id="category.id">
                    <div :class="itemClass(item)" v-for="item in category.children" :key="item.id" :data-id="item.id">
                        
                        <trax-ui-checkbox class="float-left ml-1" :value="itemChecked(item.id)" @change="toggleItem($event, item.id)" v-if="!item.title">
                        </trax-ui-checkbox>

                        <p :class="itemContentClass(item)">
                            <span style="white-space: pre-wrap;">{{ item.name }}</span>
                            <span class="badge badge-default ml-1" v-for="competency in item.competencies" :key="competency">
                                {{ competency_domains_tags[competency] }}
                            </span>
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: {default: 'enac-custom-atpl-assessment-toastr'},
            withTags: null,
            indexId: null,
            learningUnitId: null,
        },

        data: function() {
            return {
                lang: lang,
                competency_endpoint: app_url+'polaris/api/front/competency-items',
                relation_endpoint: app_url+'polaris/api/front/learning-units/'+this.learningUnitId+'/competency-relations',
                toggle_endpoint: app_url+'polaris/api/front/learning-units/'+this.learningUnitId+'/competencies',
                loaded: false,
                opened: false,
                competency_domains_tags: data.competency_domains_tags,
                item_type: null,
                categories: [],
                checked: [],
                settings: null
            }
        },

        created: function() {
            this.bus.$on(this.id+'-open', this.open);
            this.bus.$on(this.id+'-tabs-changed', this.getData);
            this.bus.$on(this.id+'-load-relations', this.loadRelations);
        },

        methods: {

            itemClass(item) {
                var res = 'trax-block trax-level-2';
                if (item.title) res += ' trax-title';
                return res;
            },

            itemContentClass(item) {
                return item.title ? '' : 'trax-with-checkbox';
            },

            itemChecked(id) {
                return this.checked.indexOf(id) > -1;
            },

            toggleItem($event, itemId) {
                var that = this;
                axios.post(this.toggle_endpoint+'/'+itemId, {
                    item_type: that.settings.item_type,
                    assessment_type: that.settings.assessment_type,
                })
                .then(function (response) {
                    that.checked = response.data.data;
                })
            },

            loadRelations(settings) {
                var that = this;
                if (settings != undefined) that.settings = settings;
                axios.get(this.relation_endpoint, { params: {
                    item_type: that.settings.item_type,
                    assessment_type: settings.assessment_type,
                }}).then(function (response) {
                    that.checked = response.data.data;
                })
            },

            open() {
                this.opened = true;
                this.getData(this.item_type);
            },

            getData(item_type) {
                var that = this;
                this.item_type = item_type;
                if (!this.opened) return;
                axios.get(this.competency_endpoint, {
                    params: {
                        filters: {
                            type: item_type,
                            parent_id: {$exists: false},
                            index_id: that.indexId
                        },
                        relations: ['children'],
                        sort: ['order']
                    }})
                    .then(function (response) {
                        that.categories = response.data.data;
                        that.loaded = true;
                    })
            },

            refresh() {
                this.getData(this.item_type);
            }
        }
    }
</script>
